import React, {useState, useEffect} from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import {useHistory} from 'react-router-dom';

import './App.css';

import {Context, ContextPersist} from "./store/context"
import { AuthService } from './services/AuthService';
import ApiService from './services/ApiService';

import SignInView from './views/Auth/SignInView';
import RegisterView from './views/Auth/RegisterView';
import ForgottenPasswordView from './views/Auth/ForgottenPasswordView';
import UnsubscribeRequestView from './views/Auth/UnsubscribeRequestView';
import PendingUnsubscribeView from './views/Auth/PendingUnsubscribeView';
import CreatedAccountView from './views/Auth/CreatedAccountView';
import ConfirmAccountView from './views/Auth/ConfirmAccountView';
import ConfirmUnsubscribeView from './views/Auth/ConfirmUnsubscribeView';
import ChangePasswordView from './views/Auth/ChangePasswordView';
import HomeView from './views/Home/HomeView';
import ResetPasswordView from "./views/Auth/ResetPasswordView";
import ChangePasswordConfirmedView from "./views/Auth/ChangePasswordConfirmedView";
import AltaDebitoView from "./views/DebitoAutomatico/AltaDebitoView";

import FidelizarView from "./views/UnidadFacturacion/Fidelizar/FidelizarView";
import UnidadesAdheridasView from "./views/UnidadFacturacion/UnidadesAdheridas/UnidadesAdheridasView";
import ConsumoView from "./views/UnidadFacturacion/Consumo/ConsumoView";
import VincularView from "./views/UnidadFacturacion/Vincular/VincularView";

import ConsultaYDescargaView from "./views/Factura/ConsultaYDescarga/ConsultaYDescargaView";
import TuFacturaView from "./views/Factura/TuFactura/TuFacturaView";

import PagosRealizadosView from "./views/Factura/PagosRealizados/PagosRealizadosView";

import MetodosPagosView from "./views/Pagos/Metodos/MetodosPagosView";
import PagoExitosoView from "./views/Pagos/Resultados/PagoExitosoView";
import PagoPendienteView from "./views/Pagos/Resultados/PagoPendienteView";
import PagoRechazadoView from "./views/Pagos/Resultados/PagoRechazadoView";

import NotFoundView from "./views/NotFound/NotFoundView";

import Modal from 'components/atoms/Modal';


function App() {
    const history = useHistory();

    const [user, setUser] = useState(null);
    const [load, setLoad] = useState(false);
    const [showServerError, setShowServerError] = useState(false);

    useEffect(() => {
        AuthService.loadUser()
            .then(user => {
                setUser(user);
                setLoad(true);
            }).catch(error => {
                setLoad(true);
            }
        );

        const currentUserObserver = AuthService.currentUser.subscribe(user_event => {
            if (user != null && user_event === null) {
                history.push('/login');
            }
            // Obligo a renderizar entonces refresca bien los permisos
            setUser(user_event);
        });

        const currentCode500Observer = ApiService.code500Subject.subscribe(response => {
            // CUIDADO con el history.push que podes quedar en loop
            setShowServerError(true);
        });

        return function cleanup() {
            currentUserObserver.unsubscribe();
            currentCode500Observer.unsubscribe();
        }
    }, []);

    const bodyServerError = <span className="show-server-error">
        <h3>Error en los servicios de ABSA</h3>
        <p>En estos momentos los servidores se encuentran con mucha carga
            y puede haber algunos problemas.</p>
    </span>;


    return (
        <ContextPersist><Context>

        <main>
            <Switch>
                <React.Fragment>
                    { (load && !user) &&
                    <div>
                        <Route path='/login' component={SignInView} />
                        <Route path='/registrar' component={RegisterView} />
                        <Route path='/olvide_password' component={ForgottenPasswordView} />
                        <Route path='/cuenta_creada' component={CreatedAccountView} />
                        <Route path='/confirmar/:token' component={ConfirmAccountView} />
                        <Route path='/confirmar_baja/:token' component={ConfirmUnsubscribeView} />
                        <Route path='/resetear_password/:token' component={ResetPasswordView} />
                        <Route path='/confirmar_password' component={ChangePasswordConfirmedView} />
                       
                        {/* Rutas con autenticacion */}
                        <Route exact path="/">
                            <Redirect to="/login" />
                        </Route>
                        <Route exact path="/home">
                            <Redirect to="/login" />
                        </Route>
                        <Route exact path="/solicitud_baja">
                            <Redirect to="/login" />
                        </Route>
                        <Route exact path="/solicitud_baja_enviada">
                            <Redirect to="/login" />
                        </Route>
                        <Route exact path="/cambiar_password">
                            <Redirect to="/login" />
                        </Route>
                        <Route exact path="/vincular">
                            <Redirect to="/login" />
                        </Route>
                        <Route exact path="/desvincular">
                            <Redirect to="/login" />
                        </Route>
                        <Route exact path="/unidades_adheridas">
                            <Redirect to="/login" />
                        </Route>
                        <Route exact path="/consulta_descarga_facturas">
                            <Redirect to="/login" />
                        </Route>
                        <Route exact path="/consulta_tu_factura">
                            <Redirect to="/login" />
                        </Route>
                        <Route exact path="/pagos_realizados">
                            <Redirect to="/login" />
                        </Route>
                        <Route exact path="/fidelizar/:id">
                            <Redirect to="/login" />
                        </Route>
                        <Route exact path="/metodos_pagos">
                            <Redirect to="/login" />
                        </Route>
                            <Route exact path="/pago_exitoso/:id/:external_reference">
                            <Redirect to="/login" />
                        </Route>
                            <Route exact path="/pago_pendiente/:id/:external_reference">
                            <Redirect to="/login" />
                        </Route>
                            <Route exact path="/pago_rechazado/:id/:external_reference">
                            <Redirect to="/login" />
                        </Route>
                        <Route exact path="/consumos">
                            <Redirect to="/login" />
                        </Route>
                        <Route exact path="/alta-debito/:id/:campo">
                            <Redirect to="/login" />
                        </Route>
                        {/* <Route component={NotFoundView} /> */}
                    </div>
                    }
                    { (load && user) &&
                    <div>
                        <Route path='/home' component={HomeView} />
                        <Route path='/solicitud_baja' component={UnsubscribeRequestView} />
                        <Route path='/solicitud_baja_enviada' component={PendingUnsubscribeView} />
                        <Route path='/cambiar_password' component={ChangePasswordView} />
                        <Route path='/confirmar_baja/:token' component={ConfirmUnsubscribeView} />
                        <Route path='/confirmar_password' component={ChangePasswordConfirmedView} />
                        {/*Unidad Facturacion*/}
                        <Route path='/unidades_adheridas' component={UnidadesAdheridasView} />
                        <Route path='/vincular' component={VincularView} />
                        <Route path='/desvincular' component={VincularView} />
                        {/*Factura*/}
                        <Route path='/consulta_descarga_facturas' component={ConsultaYDescargaView} />
                        <Route path='/consulta_tu_factura' component={TuFacturaView} />

                        {/*Pagos Realizados*/}
                        <Route path='/pagos_realizados' component={PagosRealizadosView} />

                        {/*Fidelización*/}
                        <Route path='/fidelizar/:id' component={FidelizarView} />

                        {/*Pagos*/}
                        <Route path='/metodos_pagos' component={MetodosPagosView} />
                        <Route path='/pago_exitoso/:id/:external_reference/:tipo_pago' component={ConsultaYDescargaView} />
                        <Route path='/pago_pendiente/:id/:external_reference/:tipo_pago' component={ConsultaYDescargaView} />
                        <Route path='/pago_rechazado/:id/:external_reference/:tipo_pago' component={ConsultaYDescargaView} />

                        {/*Alta Debito*/}
                        <Route path='/alta-debito/:id/:campo' component={AltaDebitoView} />

                        <Route path='/consumos' component={ConsumoView} />


                        {/* Rutas sin autenticacion */}
                        <Route exact path="/">
                            <Redirect to="/home" />
                        </Route>
                        <Route exact path="/login">
                            <Redirect to="/home" />
                        </Route>
                        <Route exact path="/registrar">
                            <Redirect to="/home" />
                        </Route>
                        <Route exact path="/olvide_password">
                            <Redirect to="/home" />
                        </Route>
                        <Route exact path="/cuenta_creada">
                            <Redirect to="/home" />
                        </Route>
                        <Route exact path="/confirmar/:token">
                            <Redirect to="/home" />
                        </Route>
                        {/* <Route component={NotFoundView} /> */}
                    </div>
                    }
                </React.Fragment>
            </Switch>

            <Modal
                className="modal-server-error"
                show={showServerError}
                title={"Upps!"}
                body={bodyServerError}
                legend={"Recargar Sitio"}
                action={() => {window.location.reload()}}
                handleClose={() => {setShowServerError(false)}}
            />
        </main>
        </Context></ContextPersist>

    );
}

export default App;
